var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBeach = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.3 18.1c.1-.5.1-.9.1-.9v-.6c0-2.6-1.5-7.1-5.6-7.1-2.6 0-3.3 2.1-3.3 4.7 0 .4 0 .8.1 1.2q.15.9.3 2.1l.4 3.3c0 .3.1.6.1.9 0 1.9.3 6.9.3 6.9 0 1.8 1.3 2.9 3.1 3 2 0 3.4-1.2 3.4-3l.6-6.2c.1-.1.4-3 .5-4.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.5 14.3c-.4.5-.8 1.2-1.1 1.6-.8 1.4-1.1 4-1.1 4M26.3 14.2q.75.6 1.5 1.5c1.5 1.8 2.3 4.3 2.3 4.3M10.6 18.1c0-.5-.1-.8-.1-.9v-.6c0-2.6 1.5-7.1 5.6-7.1 2.6 0 3.3 2.1 3.3 4.7 0 .4 0 .8-.1 1.2 0 .6-.2 1.3-.3 2.1l-.4 3.3c0 .3-.1.6-.1.9 0 1.9-.3 6.9-.3 6.9 0 1.8-1.3 2.9-3.1 3-2 0-3.4-1.2-3.4-3l-.6-6.2c0-.1-.3-3-.5-4.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 14.3c.3.6.8 1.2 1 1.7.8 1.4 1.2 3.9 1.2 3.9M14.7 14.2q-.75.6-1.5 1.5c-1.6 1.8-2.4 4.3-2.4 4.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.6 13a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4ZM25.4 13a1.2 1.2 0 1 1 0 2.399 1.2 1.2 0 0 1 0-2.399Z"
}))));
export default SvgBeach;